import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import BaseComponent from '../../../../../baseClasses/BaseComponent';
import SelectMemberList from '../MobileSelectMemberList';
import SelectCompanyComboBox from '../../../../../components/SelectCompanyComboBox';
import dataModel from '../../../../../models/DataModel';
import ExpandableSection from '../../../../../components/ExpandableSection';
import UserAvatarWithName from '../../../../../components/UserAvatar/MobileUserAvatarWithName';

import './CompanyMembers.scss';

export class CompanyMembers extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      menu: null,
      showProjectMembers: false,
      showUsersAvailable: false,
      // editing: false
    };
    this.market_id = null;

    this.createSelectedMemberList = this.createSelectedMemberList.bind(this);
    this.handleChangeMembers = this.handleChangeMembers.bind(this);
    this.handleChangeAvailableUsers = this.handleChangeAvailableUsers.bind(this);
  }

  handleLoadMarket() {
    const { project } = this.props;
    this.market_id = project.market_id;
    this.setState({ loadingMarkets: true }, () => {
      dataModel.marketsDAO.getMarket(project.market_id, project.company_id, {
        recordDescriptor: {
          market:
          {
            market_users:
              // TODO: show market uses special serialization and as such
              // does not handle profile_image (which is not a true attribute)
              // may need to handle that eventually (or figure out why it is
              // not)
              //{ user: { additionalFields: ["profile_image"]} },
              { user: {} },
            market_vendor_users:
            {
              //vendor_user: { additionalFields: ["profile_image"], companies: {}},
              vendor_user: { companies: {} },
            },
            // vendor_users: { additionalFields: ["profile_image"], companies: {}},
            vendor_users: { companies: {} },
          },

        },
      }).then(market => {
        this.setState({ loadingMarkets: false });
        if (market) {
          let users = [];
          if (market.market_users) {
            market.market_users.forEach(market_user => {
              if (market_user.user && market_user.user.id && !market_user.user.suspended) {
                users.push(market_user.user);
              }
            });
          }
          this.setState({ users: users, market: market });
          if (this.state.selectedCompany && this.state.market) {
            this.handleSetVendorUsers(this.state.selectedCompany, this.state.market);
          }
        }
      })
        .catch((error) => {
          this.market_id = null;
        });
    });
  }

  componentDidMount() {
    const { project } = this.props;

    dataModel.companiesDAO.getCompany(this.props.project.company_id,
      {
        recordDescriptor: {
          company: {
            vendor_companies: { additionalFields: ['is_vendor_company'] },
            teams: {},
            additionalFields: ['logo'],
          },
        },
      })
      .then(projectCompany => {
        if (!projectCompany) {
          projectCompany = this.props.project.company;
        }
        const companyList = this.createCompanyList(projectCompany);
        if (companyList.length > 0 && this.state.market) {
          this.handleSetVendorUsers(companyList[0], this.state.market);
        }
        this.setState({
          projectCompany: projectCompany,
          selectedCompany: companyList.length > 0 ? companyList[0] : null,
        });
      });

    if (project && project.market_id) {
      this.handleLoadMarket();
    }
  }

  componentDidUpdate(prevProps) {
    const { project } = this.props;
    if (prevProps.requestClose != this.props.requestClose) {
      this.handleClose();
    }
    if (project && project.market_id && project.market_id != this.market_id) {
      this.handleLoadMarket();
    }
  }

  handleSetVendorUsers(company, market) {
    if (company.id != this.props.currentCompany.id && market) {
      let vendor_users = market.market_vendor_users.filter(
        marketVendorUser => {
          return marketVendorUser.vendor_company_id == company.id;
        }
      );
      vendor_users = vendor_users.map(vendorUser => {
        return vendorUser.vendor_user;
      });
      this.setState({ vendorUsers: vendor_users });
    }
  }

  handleCompanySelection(company) {
    this.handleSetVendorUsers(company, this.state.market);
    this.setState({ selectedCompany: company });
  }

  createCompanyList(projectCompany) {
    let projectCompanies = [];
    if (projectCompany) {
      if ((!this.props.isBuildOwner && this.props.permissions.canAddProjectMembers)
        || (this.props.isBuildOwner &&
          projectCompany.id == this.props.currentUser.companies[0].id)) {
        projectCompanies.push(projectCompany);
      }
      if (projectCompany.vendor_companies) {
        projectCompany.vendor_companies.forEach(vendor => {
          projectCompanies.push(vendor);
        });
      }
    }
    return projectCompanies;
  }

  createSelectedMemberList() {
    let selectedMembers = null;
    if (this.props.projectMembers && this.props.projectMembers.length > 0) {
      selectedMembers = this.props.projectMembers.filter(member => {
        if (member.first_name) {
          member.name = member.first_name + ' ' + member.last_name;
        }
        /*
                if (this.props.isBuildOwner || this.props.permissions.canEditProject) {
                  if (member.companies && member.companies.length && member.companies[0].id == this.props.currentCompany.id) {
                    return true
                  }
                  else {
                    return false
                  }
                }
        */
        return true;
      }, this);

      selectedMembers.sort((u1, u2) => {
        if (u1.name.toLowerCase() < u2.name.toLowerCase()) {
          return -1;
        } else if (u1.name.toLowerCase() > u2.name.toLowerCase()) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    return selectedMembers;
  }

  createMemberSelectionList() {
    if (this.state.users) {
      const { projectMembers } = this.props;
      let users = [];
      if (this.state.selectedCompany && this.state.selectedCompany.id == this.props.currentCompany.id) {
        users = this.state.users.map(user => {
          user.company = Object.assign({}, this.props.currentCompany);
          return user;
        });
      }
      else {
        users = this.state.vendorUsers;
      }
      let membersSelectionList = !users ? [] : users.filter(user => {
        let findUser = null;
        if (projectMembers) {
          findUser = projectMembers.find((member) => {
            if (member.first_name || member.last_name) {
              return member.id == user.id;
            }
            else {
              // check the team users...
              return member.users.find((teamUser) => {
                return teamUser.id == user.id;
              });
            }
          });
        }
        if (user.super_admin || findUser) {
          return false;
        }
        else {
          user.name = user.first_name + ' ' + user.last_name;
          return true;
        }
      });
      return membersSelectionList.sort((u1, u2) => {
        if (u1.name.toLowerCase() < u2.name.toLowerCase()) {
          return -1;
        } else if (u1.name.toLowerCase() > u2.name.toLowerCase()) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    return [];
  }

  cancelChange = () => {
    dataModel.systemPopup = null;
  };

  createTeamsList() {
    let { project } = this.props;
    const selectedMembers =project.project_users;
   
    selectedMembers.map((member) => {
     
      const teamMembers =<UserAvatarWithName key={member.id} user={member} selectUser={this.handleSelectMember} option={this.props.type}/>;
      
      return (
        <ExpandableSection
          initiallyExpanded={false}
          name={'dispobinles'}
          key={member.id}
          animateExpand={this.props.animateExpand}
          // icon={member.logo || memberIconBlue}
          onClick={this.props.handleAddMember}
          onClickData={member}
        >
          <div className="team-teams-members">
            { teamMembers }
          </div>
        </ExpandableSection>
      );
    });
  }

  showProjectMembers(state){
    var x = document.getElementById('mobile-membersproject');
    if (state == false) {
      x.style.display = 'none';
    } else{
      x.style.display = 'block';
    }

    //  if (this.state.showUsersAvailable == false) {
    //   x.style.display = "none";
    //  } else{
    //   x.style.display = "block";
    //  }
  }

  handleChangeMembers(checked){
    this.setState({ showProjectMembers: checked });
  }

  handleChangeAvailableUsers(checked){
    this.setState({ showUsersAvailable: checked });
  }
  sortByName(a,b) {
    const aName = a.first_name.toUpperCase() + ' ' + a.last_name.toUpperCase();
    const bName = b.first_name.toUpperCase() + ' ' + b.last_name.toUpperCase();
    if (aName < bName)
      return -1;
    if (aName > bName)
      return 1;
    return 0;
  }
  render() {
    let { project } = this.props;
    const { projectCompany } = this.state;
    if (project == undefined) {
      return null;
    }

    const companyList = this.createCompanyList(projectCompany);
    const selectedMembers = this.createSelectedMemberList();
    const membersSelectionList = this.createMemberSelectionList();
    if (membersSelectionList && membersSelectionList.length) { membersSelectionList.sort(this.sortByName); }
    let totalTeams=0;
    if(selectedMembers && selectedMembers.length) {
      selectedMembers.map(member =>{
        if(!member.first_name){
          totalTeams+=1;
        }
        return totalTeams;
      });
    }
    
    return (
      <div className="mobile-company-members-main-body">
        <div className="mobile-left-side">
          <div className="mobile-selection-section company-section">    
            {     
              <div className="mobile-selection-section user-section">
                {
                  selectedMembers && selectedMembers.length>0 ?
                  <SelectMemberList
                  members={selectedMembers}
                  type='project'
                  selectMember={this.props.handleRemoveMember}
                  project={this.props.project}
                  title={totalTeams>0?'project members ('+(parseInt(selectedMembers.length,10) -parseInt(totalTeams,10))+') teams ('+totalTeams+')': 'project members ('+selectedMembers.length+')'}
                />: null
                }
              </div>

            } 
            <div className="mobile-label">SELECT COMPANY </div>
            <div className="mobile-combo-box-container">   
              <SelectCompanyComboBox
                id={'select-vendor-company-combobox'}
                key={'select-vendor-company-combobox'}
                width={300}
                hasBorder={true}
                noBackground={false}
                handleSelection={this.handleCompanySelection}
                currentSelectedCompany={this.state.selectedCompany}
                adjustHeight={true}
                companies={companyList}
                ubication={'mobile'}
               />
            </div>
            <div className="mobile-selection-section user-section">                
                {/* <hr className="mobile-dividing-line"/> */}
                {
                  
                  <SelectMemberList
                  members={membersSelectionList}
                  type='available'
                  selectMember={this.props.handleAddMember}
                  project={this.props.project}
                  showProjectMembers={this.handleChangeMembers}
                  title={'available users'}
                />
                }
               
                {/* <hr/> */}
              
             </div>
          </div>
      
        </div>
        {/* <div className="right-side">
      
        </div> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.new_users.currentUser,
    permissions: state.new_users.permissions,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(CompanyMembers);



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectCRUD/MobileSelectProjectMember/MobileCompanyMembers/index.js